import { render, staticRenderFns } from "./BoxStyle.vue?vue&type=template&id=2e6b9ae8&"
import script from "./BoxStyle.vue?vue&type=script&lang=js&"
export * from "./BoxStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports